import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Monitor, Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

interface Props {
  variant?: 'icon' | 'menu-item'
}

export function ThemeToggle({ variant = 'icon' }: Props) {
  const { theme, setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  // Avoid hydration flash before next-themes resolves the saved value.
  if (!mounted) {
    return (
      <Button size="icon" variant="ghost" aria-label="Theme" disabled>
        <Sun className="size-4" />
      </Button>
    )
  }

  const isDark = (theme === 'system' ? resolvedTheme : theme) === 'dark'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size={variant === 'icon' ? 'icon' : 'sm'}
          variant="ghost"
          aria-label="Theme"
          title={`Theme: ${theme}`}
        >
          {isDark ? <Moon className="size-4" /> : <Sun className="size-4" />}
          {variant === 'menu-item' && (
            <span className="ml-2 capitalize">{theme}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme('light')}>
          <Sun className="size-4" /> Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          <Moon className="size-4" /> Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('system')}>
          <Monitor className="size-4" /> System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
